// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5600) return "static/chunks/05f6971a-86f8c1283059abf0.js";
	if (chunkId === 329) return "static/chunks/329-04ee9547df635d11.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"113":"9aa07f5cf0e620e7","1490":"16700e2c6edc9b63","2478":"52fefdff665a1395","2499":"102882445b194b0a","2693":"6b8242275132ca72","4323":"846c7946d80f8864","5052":"a999520b2ae8dff3","8749":"4a4224d978114be0"}[chunkId] + ".js";
};